import { makeStyles } from "@material-ui/core";

const useRbAutocompleteControlStyles = makeStyles({
  inputRoot: {
    paddingBottom: "2px !important",
    "&.MuiInputBase-adornedStart": {
      padding: "2px 56px 2px 3px !important",
    },
  },
});

export default useRbAutocompleteControlStyles;
